const hasSessionStorage = () =>
  typeof window !== "undefined" && typeof window.sessionStorage !== "undefined";

export const readSessionUiState = (key, fallbackValue = null) => {
  if (!key || !hasSessionStorage()) {
    return fallbackValue;
  }

  try {
    const rawValue = window.sessionStorage.getItem(key);
    return rawValue ? JSON.parse(rawValue) : fallbackValue;
  } catch (error) {
    console.error("No pudimos leer el estado visual guardado:", error);
    return fallbackValue;
  }
};

export const writeSessionUiState = (key, value) => {
  if (!key || !hasSessionStorage()) {
    return;
  }

  try {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error("No pudimos guardar el estado visual:", error);
  }
};

export const removeSessionUiState = (key) => {
  if (!key || !hasSessionStorage()) {
    return;
  }

  try {
    window.sessionStorage.removeItem(key);
  } catch (error) {
    console.error("No pudimos limpiar el estado visual guardado:", error);
  }
};
